import type { Events } from '@george-web/event-factory';

import { type PublicTemporaryMessage } from '@api-client/temporary-messages';
import { trackEvent2 } from '@shared/statistics';

const trackTemporaryMessage = (
    message: PublicTemporaryMessage,
    name: keyof Events['temporaryMessages'],
    trigger: string | undefined,
): void => {
    trackEvent2('temporaryMessages', name, {
        messageId: message.id,
        trigger: trigger ?? '<path-is-not-matching-screen>',
        severity: message.severity,
        closeable: message.closeable,
        messageTitle: message.localizedText.title ?? '<title-not-defined>',
        messagePreview: message.localizedText.preview ?? '<preview-not-defined>',
    });
};

export const trackTemporaryMessageDisplayed = (
    message: PublicTemporaryMessage,
    trigger: string | undefined,
): void => {
    trackTemporaryMessage(message, 'temporaryMessageSeen', trigger);
};

export const trackTemporaryMessageSelected = (
    message: PublicTemporaryMessage,
    trigger: string | undefined,
): void => {
    trackTemporaryMessage(message, 'temporaryMessageSelected', trigger);
};

export const trackTemporaryMessageClosed = (
    message: PublicTemporaryMessage,
    trigger: string | undefined,
): void => {
    trackTemporaryMessage(message, 'temporaryMessageClosed', trigger);
};
